// components/Loader.tsx
"use client";

import React from 'react';
import './loader.scss';

const Loader: React.FC = () => {
  return (
    <div className="silvr-loader">
      <svg className="spinner-svg" width="64" height="64" viewBox="0 0 50 50">
        <circle className="spinner-bg" cx="25" cy="25" r="20" fill="none" stroke="#222" strokeWidth="6" />
        <circle className="spinner-fg" cx="25" cy="25" r="20" fill="none" stroke="#ff3b30" strokeWidth="6" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default Loader;
